const ScrollLinkEnum = Object.freeze({
    HOME: "HOME",
    BUY_NFTS: "BUY NFTS",
    DESCRIPTION: "DESCRIPTION",
    FAQ: "FAQ",
    NFTENDOS: "NFTENDOS",
    NONE: "NONE"
})

export default ScrollLinkEnum;